import { Skeleton } from '@mui/material';
import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import './banner.css';

function Banners({banners, loading, error}) {

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  // Mobile banner images array
  const mobileImages = [
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/1.png`,
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/2.png`,
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/3.png`,
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/4.png`,
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/5.png`,
    `${process.env.PUBLIC_URL}/assets/images/mobile-slider/6.png`,
    // `${process.env.PUBLIC_URL}/assets/images/mobile-slider/7.png`
  ];

  if(error) {
    return (
      <div className="container w-100">
        <div className="carousel slide">
          <p>something Went wrong</p>	
        </div>
      </div>
    )
  }

  return (
    <>
      {/* Desktop Carousel */}
      <div className="container w-100 d-none d-md-block">
        <Carousel 
          fade 
          interval={4000}
          controls={true}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {loading ? (
            <Carousel.Item>
              <Skeleton variant="rectangular" width="100%" height={400} />
            </Carousel.Item>
          ) : (
            banners?.map((item, index) => (
              <Carousel.Item key={item._id} interval={4000}>
                <div className="banner-image-container">
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    className="banner-image-placeholder"
                    style={{ position: 'absolute', display: 'block' }}
                  />
                  <img
                    loading='lazy'
                    src={item.image}
                    className="d-block w-100 img-fluid banner-image"
                    alt="Banner"
                    onLoad={(e) => {
                      const skeleton = e.target.previousSibling;
                      if (skeleton) skeleton.style.display = 'none';
                    }}
                  />
                  <div className="product-image-overlay position-absolute top-0 left-0 h-full w-full"></div>
                </div>
                <Carousel.Caption className="image-caption d-md-block">
                  {/* <h1>{item.mainText}</h1> */}
                  {/* <h5>{item.subText}</h5> */}
                </Carousel.Caption>
              </Carousel.Item>
            ))
          )}
        </Carousel>
      </div>

      {/* Mobile Carousel */}
      <div className="container-fluid d-md-none px-0">
        <Carousel
          fade
          interval={4000}
          controls={true}
          indicators={true}
          pause={false}
        >
          {loading ? (
            <Carousel.Item>
              <Skeleton variant="rectangular" width="100%" height={300} />
            </Carousel.Item>
          ) : (
            mobileImages.map((image, index) => (
              <Carousel.Item key={index} interval={4000}>
                <div className="banner-image-container mobile">
                  <Skeleton 
                    variant="rectangular" 
                    width="100%" 
                    height="100%" 
                    className="banner-image-placeholder" 
                    style={{ position: 'absolute', display: 'block' }}
                  />
                  <img
                    loading="lazy"
                    src={image}
                    className="d-block w-100 banner-image mobile-banner-image"
                    alt={`Mobile Slide ${index + 1}`}
                    onLoad={(e) => {
                      const skeleton = e.target.previousSibling;
                      if (skeleton) skeleton.style.display = 'none';
                    }}
                  />
                </div>
              </Carousel.Item>
            ))
          )}
        </Carousel>
      </div>
    </>
  );
}

export default Banners;